import React from "react";
import { ComponentType, useState, useEffect } from 'react';
import {
  lighten, Icon, styled, Grid, IconButton, ListItemIcon,
  Divider, Container, Card, CardActionArea, CardContent, Typography, CardHeader
} from '@mui/material';
import { DivBox, InfoBox } from '../../StyledComponents/styled';
import InsightsIcon from '@mui/icons-material/Insights';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import TextField from '@mui/material/TextField';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import SaveIcon from '@mui/icons-material/Save';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import GridView from '../../components/GridView/index';
import Insights from '../../components/Insights/index';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { Supplier as SupplierType } from '../../types/Supplier';
import {useSelector} from 'react-redux'
import toast, { Toaster } from 'react-hot-toast';
import { SaveSupplierData, GetSupplierData } from "../../services/supplier-service";
import { useForm } from "react-hook-form";

export const Supplier = () => {
  const username = useSelector(state => state["users"].email)
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [selectedMode, setSelectedMode] = useState<String>('History');
  const [supplierlist, setSupplierlist] = useState([]);
  const [SupplierData, setSupplierData] = useState<SupplierType>({
    ID: 0,
    supplier_code: '',
    supplier_type: 'Purchase',
    branch: '',
    name: '',
    GST: '',
    PanNo: '',
    office_address: '',
    office_city: '',
    office_pincode: '',
    office_state: '',
    office_country: '',
    office_phone: '',
    office_mobile: '',
    office_email: '',
    factory_address: '',
    factory_city: '',
    factory_pincode: '',
    factory_state: '',
    factory_country: '',
    factory_phone: '',
    factory_mobile: '',
    factory_email: '',
    CreatedBy: username,
    CreatedDate: '',
    UpdatedBy: '',
    UpdatedDate: ''
  });

  const handleInfoModeChange = (mode: String) => {
    setSelectedMode(mode);
  }

  const loadSuppliers = async () => {
    const itemsdata = await GetSupplierData('');
    setSupplierlist(itemsdata)
  }

  useEffect(() => {
    loadSuppliers();
  }, []);

  const handleBranchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.branch = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleSuppTypeChange = (event) => {
    if (SupplierData != undefined) {
      SupplierData.supplier_type = event.target.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.name = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleGSTChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.GST = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handlePanNoChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.PanNo = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleOfficeAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.office_address = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleOffCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.office_city = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleOffPincodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.office_pincode = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleOffStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.office_state = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleOffCountryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.office_country = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleOffPhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.office_phone = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleOffMobileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.office_mobile = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleOffEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.office_email = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleFactoryAddressChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.factory_address = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleFactoryCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.factory_city = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleFactoryPincodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.factory_pincode = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleFactoryStateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.factory_state = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleFactoryCountryChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.factory_country = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleFactoryPhoneChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.factory_phone = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleFactoryMobileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.factory_mobile = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const handleFactoryEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (SupplierData != undefined) {
      SupplierData.factory_email = event.currentTarget.value;
    }
    const newData = JSON.parse(JSON.stringify(SupplierData));
    setSupplierData(newData);
  }

  const SupplierCodes = [
    { label: 'Supplier 1', id: 1 },
    { label: 'Supplier 2', id: 2 },
    { label: 'Supplier 3', id: 3 }
  ]

  const handleSaveClick = async () => {
    let data = await SaveSupplierData(SupplierData);
    if (data != undefined && data.succeeded) {
      toast.success('Successfully created supplier!');
      loadSuppliers();
      setSupplierData({
        ID: 0,
        supplier_code: '',
        supplier_type: 'Purchase',
        branch: '',
        name: '',
        GST: '',
        PanNo: '',
        office_address: '',
        office_city: '',
        office_pincode: '',
        office_state: '',
        office_country: '',
        office_phone: '',
        office_mobile: '',
        office_email: '',
        factory_address: '',
        factory_city: '',
        factory_pincode: '',
        factory_state: '',
        factory_country: '',
        factory_phone: '',
        factory_mobile: '',
        factory_email: '',
        CreatedBy: username,
        CreatedDate: '',
        UpdatedBy: '',
        UpdatedDate: ''
      });
    }
    else {
      toast.error('Error in creating Supplier please try again!');
    }
  }

  const columns = [
    {
      field: 'label',
      headerName: 'Name',
      width: '100%',
      renderCell: (params) => (
        <button onClick={() => handleHistoryOnclick(params.row.value)} className="btn btn-link">
          {params.row.label}
        </button>
      )
    }
  ];

  const handleHistoryOnclick = async (id) => {
    const itemsdata = await GetSupplierData(id);
    setSupplierData(itemsdata[0]);
  }

  const handleClearAll = () => {
    toast.success('Supplier Data Cleared!');
    setSupplierData({
      ID: 0,
        supplier_code: '',
        supplier_type: "Purchase",
        branch: '',
        name: '',
        GST: '',
        PanNo: '',
        office_address: '',
        office_city: '',
        office_pincode: '',
        office_state: '',
        office_country: '',
        office_phone: '',
        office_mobile: '',
        office_email: '',
        factory_address: '',
        factory_city: '',
        factory_pincode: '',
        factory_state: '',
        factory_country: '',
        factory_phone: '',
        factory_mobile: '',
        factory_email: '',
        CreatedBy: username,
        CreatedDate: '',
        UpdatedBy: '',
        UpdatedDate: ''
    });
  }

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={10}>
          <DivBox>
            <CardHeader
              action={
                <ListItemIcon>
                  <IconButton size="large">
                    <SaveIcon onClick={handleSubmit(handleSaveClick)} />
                  </IconButton>
                  <IconButton size="large">
                    <ClearAllIcon onClick={handleClearAll} />
                  </IconButton>
                </ListItemIcon>
              }
              title="Supplier Master"
              subheader=""
            />
            <Divider />
            <CardContent style={{ paddingTop: '50px', maxWidth: '2000px', height: '90%', overflowY: 'scroll' }}>
              <Container>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      disabled
                      id="outlined-required"
                      label="Supplier Code"
                      value={SupplierData?.supplier_code}
                      sx={{ m: 1, width: '100%' }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel id="supplier-type-label" style={{ margin: '8px' }}>Supplier Type</InputLabel>
                      <Select
                        labelId="supplier-type-label"
                        id="supplier-type-select"
                        value={SupplierData?.supplier_type}
                        label="Supplier Type"
                        onChange={handleSuppTypeChange}
                        style={{ margin: '8px', width: '100%' }}
                      >
                        <MenuItem value={"Purchase"}>Purchase</MenuItem>
                        <MenuItem value={"Subcontract"}>Subcontract</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      required
                      id="outlined-required"
                      label="Branch"
                      value={SupplierData?.branch}
                      {...register("branch", { required: true })}
                      onChange={handleBranchChange}
                      sx={{ m: 1, width: '100%' }}
                    />
                    {errors.branch && errors.branch.type === "required" && <span style={{ color: 'red', marginLeft: '10px' }}>This is required</span>}
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      required
                      id="outlined-required"
                      label="Name"
                      value={SupplierData?.name}
                      {...register("name", { required: true })}
                      onChange={handleNameChange}
                      sx={{ m: 1, width: '100%' }}
                    />
                    {errors.name && errors.name.type === "required" && <span style={{ color: 'red', marginLeft: '10px' }}>This is required</span>}
                  </Grid>
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      id="outlined-required"
                      label="GST"
                      value={SupplierData?.GST}
                      onChange={handleGSTChange}
                      sx={{ m: 1, width: '100%' }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      required
                      id="outlined-required"
                      label="Pan"
                      value={SupplierData?.PanNo}
                      onChange={handlePanNoChange}
                      sx={{ m: 1, width: '100%' }}
                    />
                  </Grid>
                </Grid>
                <Card style={{ marginTop: '25px' }}>
                  <CardActionArea>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Office
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Address"
                            value={SupplierData?.office_address}
                            onChange={handleOfficeAddressChange}
                            multiline
                            rows={4}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="City"
                            value={SupplierData?.office_city}
                            onChange={handleOffCityChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Pincode"
                            value={SupplierData?.office_pincode}
                            onChange={handleOffPincodeChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="State"
                            value={SupplierData?.office_state}
                            onChange={handleOffStateChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Country"
                            value={SupplierData?.office_country}
                            onChange={handleOffCountryChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Phone"
                            value={SupplierData?.office_phone}
                            onChange={handleOffPhoneChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Mobile"
                            value={SupplierData?.office_mobile}
                            onChange={handleOffMobileChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Email"
                            value={SupplierData?.office_email}
                            onChange={handleOffEmailChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </CardActionArea>
                </Card>
                <Card style={{ marginTop: '25px' }}>
                  <CardActionArea>
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="div">
                        Factory
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Address"
                            value={SupplierData?.factory_address}
                            onChange={handleFactoryAddressChange}
                            multiline
                            rows={4}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="City"
                            value={SupplierData?.factory_city}
                            onChange={handleFactoryCityChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Pincode"
                            value={SupplierData?.factory_pincode}
                            onChange={handleFactoryPincodeChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="State"
                            value={SupplierData?.factory_state}
                            onChange={handleFactoryStateChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Country"
                            value={SupplierData?.factory_country}
                            onChange={handleFactoryCountryChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Phone"
                            value={SupplierData?.factory_phone}
                            onChange={handleFactoryPhoneChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Mobile"
                            value={SupplierData?.factory_mobile}
                            onChange={handleFactoryMobileChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            required
                            id="outlined-required"
                            label="Email"
                            value={SupplierData?.factory_email}
                            onChange={handleFactoryEmailChange}
                            sx={{ m: 1, width: '100%' }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Container>
            </CardContent>
          </DivBox>
        </Grid>
        <Grid item xs={12} md={2}>
          <InfoBox>
            <ListItemIcon style={{ margin: '15px', minWidth: '35px' }}>
              <StyledIconButton size="small" isSelected={selectedMode == 'History' ? true : false} onClick={() => handleInfoModeChange("History")}>
                <StyledIcon component={ManageSearchIcon} isSelected={selectedMode == 'History' ? true : false} />
              </StyledIconButton>
            </ListItemIcon>
            <ListItemIcon>
              <StyledIconButton size="small" isSelected={selectedMode == 'Insights' ? true : false} onClick={() => handleInfoModeChange("Insights")}>
                <StyledIcon component={InsightsIcon} isSelected={selectedMode == 'Insights' ? true : false} />
              </StyledIconButton>
            </ListItemIcon>
            <ListItemIcon style={{ float: 'right', marginTop: '8px' }}>
              <IconButton size="large">
                <AspectRatioIcon />
              </IconButton>
            </ListItemIcon>
            <Divider />
            {selectedMode == 'History' ? <GridView columns={columns} rows={supplierlist} /> : <Insights />}
          </InfoBox>
        </Grid>
      </Grid>
      <Toaster />
    </>
  );
};

const StyledIconButton = styled(IconButton)<{ isSelected: boolean }>(({ isSelected, theme }) => ({
  boxShadow: isSelected ? `0 0 0 2px ${lighten(theme.palette.primary.main, 0.6)}` : 'default',
  transition: 'box-shadow 0.1s',
}));

const StyledIcon = styled(Icon) <{ isSelected: boolean; component: ComponentType<{}> }>`
  ${({ isSelected, theme }) => isSelected && `color: ${theme.palette.primary.main};`}
`;